<template>
  <div v-if="data" class="text-static-default-hi">
    <Breadcrumb :category="data.category" />

    <TheMainContent>
      <RevContainer class="bg-surface-default-low pb-56 md:pb-72">
        <h1 class="heading-1 mt-32 text-center">
          {{ data.category.pageTitle }}
        </h1>
        <template v-if="!isNewComparisonPageActive">
          <div class="mb-56">
            <ComparisonForm
              :autocomplete-config="data.algoliaConfig.searchBox"
            />
          </div>

          <RevDivider />
        </template>

        <SuggestedCategories class="mt-56" />
      </RevContainer>
    </TheMainContent>

    <AdditionalContent :content="data.content" :custom-content-first="false" />
  </div>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevContainer } from '@ds/components/Container'
import { RevDivider } from '@ds/components/Divider'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

import AdditionalContent from '../../components/AdditionalContent/AdditionalContent.vue'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb.vue'
import ComparisonForm from '../../components/ComparisonForm/ComparisonForm.vue'
import SuggestedCategories from '../../components/SuggestedCategories/SuggestedCategories.vue'
import { useFetchCategory } from '../../composables/useFetchCategory'
import { useModelsComparisonHead } from '../../composables/useModelsComparisonHead'

const { data } = await useFetchCategory()
const country = useMarketplace().market.countryCode

const { FF_NEW_COMPARE_PAGE_ENABLED_COUNTRY_CODES } = useRuntimeConfig().public
const isNewComparisonPageActive =
  FF_NEW_COMPARE_PAGE_ENABLED_COUNTRY_CODES.includes(country)
useModelsComparisonHead(() => data.value?.content)
</script>
